export default "__VITE_ASSET__0oP4A64I__"